<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_celebration" transform="translate(-447 -547)">
      <path
        id="패스_4050"
        data-name="패스 4050"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(447 547)"
      />
      <g
        id="그룹_8642"
        data-name="그룹 8642"
        transform="translate(-0.628 0.025)"
      >
        <path
          id="패스_4064"
          data-name="패스 4064"
          fill="#21bf54"
          d="M-3727.171,718.486l12,10.057-14.743,5.257Z"
          transform="translate(4178.543 -163.8)"
        />
        <rect
          id="사각형_6098"
          data-name="사각형 6098"
          fill="#ffc304"
          width="2"
          height="7"
          transform="translate(455.56 548.975) rotate(9)"
        />
        <rect
          id="사각형_6100"
          data-name="사각형 6100"
          fill="#ffc304"
          width="2"
          height="7"
          transform="translate(468.472 558.82) rotate(77)"
        />
        <rect
          id="사각형_6099"
          data-name="사각형 6099"
          fill="#ff5c5c"
          width="2"
          height="10"
          transform="matrix(-0.829, -0.559, 0.559, -0.829, 459.684, 559)"
        />
        <circle
          id="타원_761"
          data-name="타원 761"
          fill="#087ef7"
          cx="1"
          cy="1"
          r="1"
          transform="translate(458 551)"
        />
        <rect
          id="사각형_6101"
          data-name="사각형 6101"
          fill="#087ef7"
          width="2"
          height="2"
          transform="translate(463 557)"
        />
        <rect
          id="사각형_6102"
          data-name="사각형 6102"
          fill="#21bf54"
          width="2"
          height="2"
          transform="translate(468 553)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
